<template>
  <div class="part-base-dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="900px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <!--asm 质量反馈 feedBack -->
        <feed-back ref="feed_back" v-if="modelVisible" :model="modelData" v-model="verify"></feed-back>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ i18n.com_cancel }}</el-button>
        <el-button size="small" type="primary"  @click="confirm()">{{ i18n.com_confirm }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import feedBack from '@/components/approvalCenter/feed_back';

export default {
  mixins: [dialogMixins],
  components: {
    feedBack
  },
  data() {
    return {
      modelData: {},
      modelVisible: false,
      verify: true
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.modelData = {
          ...this.model.data,
          type: 'editDone'
        };
        this.modelVisible = true;
        // this.getDetail();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // getDetail: function () {
    //   this.$getJSON(apis.feedbackInfo, { feedBackId: this.model.data.feedBackId }).then((res) => {
    //     this.modelData = res.data;
    //     this.modelVisible = true;
    //   });
    // },

    // 确认保存
    confirm: async function () {
      await this.$refs['feed_back'].onConfirm();
      const form = this.$refs['feed_back'].form;
      this.$postJSON(apis.feedbackUpdateApproveInfo, { ...form, feedBackId: this.model.data.feedBackId }, true).then(() => {
        this.$message({
          type: 'success',
          message: this.i18n.com_handle_success
        });
        this.closeDialog();
        this.$emit('success');
      });
    },

  },
};
</script>

<style lang="scss">
.part-base-dialog {
  .el-upload--text {
    height: 82px;
    width: 82px;
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .upload-bd .el-upload--text {
    width: 178px;
    height: 178px;
    .el-icon-plus {
      font-size: 28px;
    }
  }
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
}
</style>
